import { createRouter, createWebHashHistory } from 'vue-router'
import pcRoutes from './pcRoutes'
import spRoutes from './spRoutes'
import { media } from '@/utilities/utils'
import PcApp from '@/App.vue'
import SpApp from '@/SpApp.vue'

let routes = pcRoutes
let appComponent = PcApp

if (media() === 'mobile') {
    routes = spRoutes
    appComponent = SpApp
}

const router = createRouter({
    history: createWebHashHistory(),
    routes,
    scrollBehavior (_1, _2, savedPosition) {
        return savedPosition || { top: 0 }
    }
})

export default {
    router,
    appComponent,
}
